module.exports = __webpack_public_path__ + "img/jeans1.fc92e5db.png";